export default (params) => ({
  trigger: {
    name: 'product_information.click_reviews_in_product_information',
    params: params,
  },
  config: {
    schema: {
      item_id: {
        type: 'integer',
      },
    },
    event: {
      name: 'read_reviews',
      params: {
        sub_feature: null,
      },
    },
  },
});
